export enum queryKey {
  account = 'getAccount',
  cad_result = 'getCadResult',
  cad_rules = 'getCadRules',
  devices = 'getDevices',
  filter_management = 'getFilterManagement',
  filter_tree = 'getFilterTree',
  institution = 'getInstitution',
  layout_report = 'getLayouts',
  deviceStatistics = 'getDeviceStatistics',
  deviceStatisticsAll = 'getDeviceStatisticsAll',
  deviceStatistics_interval = 'getDeviceStatisticsInterval',
  orders = 'getOrders',
  orderDetail = 'getOrderDetail',
  orderWorklist = 'getOrderWorklist',
  orders_interval = 'getOrdersInterval',
  orderWorklist_interval = 'getOrderWorklistInterval',
  assigns = 'getAssigns',
  assigns_interval = 'getAssignsInterval',
  procedure = 'getProcedure',
  procedure_group = 'getProcedureGroup',
  bodyPart = 'getBodyPart',
  department = 'getDepartment',
  reports = 'getReports',
  roles = 'getRoles',
  share = 'getShare',
  share_detail = 'getShareDetail',
  studies_interval = 'getStudiesInterval',
  template_report = 'getTemplates',
  userInfo = 'userInfo',
  visited_patients = 'getVisitedPatients',
  groups = 'getGroups',
  dashboard_exam_by_radiologist = 'getDashboardExamByRadiologist',
  dashboard_perform_by_radiologist = 'getDashboardPerformByRadiologist',
  patients = 'getPatients',
  study_detail = 'getStudyDetail',
  create_attachment = 'createAttachment',
  HISOrders = 'getHISOrders',
  HISVisitOrders = 'getHISVisitOrders',
  share_infinite = 'getShareInfinite',
}
